<template>
  <div class="stc-member-item-skeleton member-product-item">
    <div class="stc-member-item-skeleton__image-container">
      <Skeleton width="100%" height="427px" border-radius="4px" />
    </div>

    <div class="stc-member-item-skeleton__order-panel">
      <!-- Title Area -->
      <div class="margin-bottom-l">
        <Skeleton width="100%" height="23px" border-radius="4px" class="margin-bottom-xs" />
        <Skeleton width="60%" height="23px" border-radius="4px" />
      </div>

      <!-- Price & Offer Area -->
      <div class="margin-bottom-l">
        <Skeleton width="120px" height="20px" border-radius="4px" class="margin-bottom-xxs" />
        <Skeleton width="200px" height="20px" border-radius="4px" />
      </div>

      <!-- Traits Area -->
      <div class="margin-bottom-l">
        <Skeleton width="150px" height="18px" border-radius="4px" class="margin-bottom-xs" />
        <div style="display: flex; gap: 8px">
          <Skeleton width="40px" height="40px" border-radius="100%" />
          <Skeleton width="40px" height="40px" border-radius="100%" />
          <Skeleton width="40px" height="40px" border-radius="100%" />
          <Skeleton width="40px" height="40px" border-radius="100%" />
        </div>
      </div>

      <!-- Size Selection Area -->
      <div class="margin-bottom-l">
        <Skeleton width="150px" height="18px" border-radius="4px" class="margin-bottom-xs" />
        <div style="display: flex; gap: 8px">
          <Skeleton width="66px" height="40px" border-radius="4px" />
          <Skeleton width="66px" height="40px" border-radius="4px" />
          <Skeleton width="66px" height="40px" border-radius="4px" />
        </div>
      </div>

      <!-- Button Area -->
      <Skeleton width="100%" height="48px" border-radius="4px" />
    </div>
  </div>
</template>

<script setup>
import Skeleton from '@atomic-ui/skeleton/Skeleton';
</script>

<style lang="scss" scoped>
@import '~settingSCSS';

.stc-member-item-skeleton {
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  gap: 24px;
}

.stc-member-item-skeleton__image-container {
  position: relative;
  flex: 0 1 342px;
  min-width: 0;
}

.stc-member-item-skeleton__order-panel {
  flex: 0 1 464px;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
</style>
